<template>
  <div id="topNav" class="bg-main">
    <b-navbar toggleable="lg" class="py-0 px-7">
      <!-- Mobile Side Menu -->
      <b-navbar-nav class="pl-0" id="sideMenuMobile" v-show="!showSearch">
        <sideMenuMobile />
      </b-navbar-nav>

      <!-- Logo -->
      <b-navbar toggleable="lg" class="py-0" style="background-color: #0255A5;"  > 
        <b-navbar-brand id="logo" class="navbar-brand mr-4" href="/"> 
          <div class="d-flex align-items-center ms-5">
            <div >
              <img :src="logo" alt="" style="height: 60px;">
            </div>
            <div class="text-start d-sm-block d-none" style="margin-top: 5px;">
              <strong style="color: #EEEEEE;font-weight: 600;">E-Learning</strong>
              <p style="color: #EEEEEE; margin: 0;font-size: 18px;font-weight: 200">
                Saturday School
              </p>
            </div>
          </div>
        </b-navbar-brand>

        <Search v-if="$router.currentRoute.name == 'Homes' || $router.currentRoute.name == 'allCourses'" @search="search" class="ml-4" v-show="!isMobile" />
      </b-navbar>
 

      <!-- Sidebar Toggle -->
      <b-navbar-toggle target="nav_sidebar" v-b-toggle.nav_sidebar >
        <b-icon-list class="text-white"></b-icon-list>
      </b-navbar-toggle>

      <!-- Desktop Auth Buttons -->
      <b-navbar-nav class="ml-auto" id="navBtn_desktopSide" v-show="!isMobile">
        <template v-if="access_token">
          <b-nav-item-dropdown right menu-class="no-padding-left">
            <template #button-content>
              <UserPanel :image="userdata.profile_image" :department="userdata.department"
                :name="`${userdata.first_name} ${userdata.last_name}`" :id="userdata.id" />
            </template>
            <b-dropdown-item @click="goto('userProfile')">โปรไฟล์</b-dropdown-item>
            <b-dropdown-item @click="logout">ออกจากระบบ</b-dropdown-item>
          </b-nav-item-dropdown>
        </template>
        <template v-else>
          <b-button class="btn  mx-1 " style="background-color: white; color: #00264E; border: none;"
            href="/login">เข้าสู่ระบบ</b-button>
          <b-button class="border-0 text-dark bg-yellow  mx-1" href="/register">ลงทะเบียน</b-button>
        </template>
      </b-navbar-nav>
    </b-navbar>

    <!-- Sidebar Menu -->
    <b-sidebar  id="nav_sidebar" style="color: white;" right shadow is-nav >
      <b-navbar-nav class="ml-auto">
        <template v-if="access_token">
          <b-nav-item-dropdown right>
            <template #button-content>
              <UserPanel :image="userdata.profile_image" :department="userdata.department"
                :name="`${userdata.first_name} ${userdata.last_name}`" :id="userdata.id" />
            </template>
            <b-dropdown-item @click="goto('userProfile')">โปรไฟล์</b-dropdown-item>
            <b-dropdown-item @click="logout">ออกจากระบบ</b-dropdown-item>
          </b-nav-item-dropdown>
        </template>
        <template v-else>
          <b-button class="btn btn-light mx-1 btnHover btnNav" href="/login">เข้าสู่ระบบ</b-button>
          <b-button class="btn btn-primary mx-1 btnHover btnNav" href="/register">ลงทะเบียน</b-button>
        </template>
      </b-navbar-nav>
    </b-sidebar>

  </div>
</template>

<script>
import logo from "./../../public/logo-2.png";
import Search from "@/components/search";
import sideMenuMobile from "@/components/sideMenuMobile";
import UserPanel from "@/components/UserPanel";
import { mapState } from "vuex";
import Swal from "sweetalert2";
import { wpDomain } from "@/util/Constants";

export default {
  name: "topNav",
  components: {
    sideMenuMobile,
    UserPanel,
    Search,
  },
  data() {
    return {
      logo,
      wpDomain,
      showSearch: false,
      isMobile: false,
    };
  },
  computed: {
    ...mapState({
      access_token: (state) => state.Auth.access_token,
      userdata: (state) => state.Auth.userData,
    }),
  },
  mounted() {
    this.checkIfMobile();
    window.addEventListener("resize", this.checkIfMobile);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkIfMobile);
  },
  methods: {
    logout() {
      this.$store.dispatch("Auth/logout").then((res) => {
        if (res === 200) {
          this.$router.push("/");
          Swal.fire("เรียบร้อย!", "ออกจากระบบเรียบร้อย", "success");
        }
      });
    },
    goto(routeName) {
      this.$router.push({ name: routeName });
    },
    getSearchInput() {
      this.showSearch = true;
    },
    hideSearchInput() {
      this.showSearch = false;
    },
    checkIfMobile() {
      this.isMobile = window.innerWidth <= 991;
    },
    search(text) {
      this.showSearch = true;
      this.$emit("search", text);
    },
  },
};
</script>

<style>
#topNav {
  border-bottom: 1px rgba(200, 187, 187, 0.2) solid !important;
  box-shadow: 0 4px 8px 0 rgba(200, 187, 187, 0.2),
    0 6px 20px 0 rgba(174, 168, 168, 0.19);
}

.btnNav {
  background-color: transparent !important;
  border: none !important;
}

#btnGetNavSearch {
  border: none !important;
}

@media screen and (min-width: 991px) {
  #sideMenuMobile {
    display: none !important;
  }

  #btnGetNavSearch {
    display: none !important;
  }
}

@media screen and (max-width: 991px) {
  #searchLg {
    display: none !important;
  }

  #navBtn_desktopSide {
    display: none !important;
  }
}
.no-padding-left{
  padding-left: 0 !important;
}
.navbar-toggler{
  border-color: white !important;
}


</style>
